import { types } from '@actions/blockedAttendees';

export default function reducer(state = [], action = {}) {
  switch (action.type) {
    case types.GET_BLOCKED_ATTENDEES.SUCCESS:
      return action.blockedAttendees;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/blockedAttendees.js